module.exports = __webpack_public_path__ + "img/code.30e8cd60.png";